import React, { Component } from 'react';
import PropTypes from 'prop-types';

import MemberSearchInputAndResults from 'containers/member/member-search-input-and-results';
import { LayoutWithHeader } from 'components/layouts';
import Container from 'components/container';


class MemberSearchContainer extends Component {
  handleRowClick = (memberId) => {
    const { history } = this.props;
    history.push(`/members/${memberId}`);
  }

  render() {
    return (
      <LayoutWithHeader pageTitle="Members" steps={[{ title: 'Members', href: '/members' }]}>
        <Container>
          <MemberSearchInputAndResults
            handleRowClick={memberId => this.handleRowClick(memberId)}
          />
        </Container>
      </LayoutWithHeader>
    );
  }
}

MemberSearchContainer.propTypes = {
  history: PropTypes.shape({}).isRequired,
};

export default MemberSearchContainer;
